import axios from 'axios'
import { runtimeConfig } from './runtimeConfig'
import { keycloak } from '../features/auth/keycloak'
import { loadTokens, saveTokens } from '../features/auth/tokenStorage'
import { requestFinished, requestStarted } from '../shared/utils/requestActivity'

const api = axios.create({
  baseURL: runtimeConfig.apiBaseUrl || '',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  async (config) => {
    requestStarted()
    try {
      if (keycloak?.authenticated) {
        await keycloak.updateToken(30)
      }
    } catch {
      // best-effort refresh
    }

    if (keycloak?.token && keycloak.refreshToken) {
      saveTokens({
        token: keycloak.token,
        refreshToken: keycloak.refreshToken,
        idToken: keycloak.idToken,
      })
    }

    const token = keycloak?.token || loadTokens()?.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    requestFinished()
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    requestFinished()
    return response
  },
  async (error) => {
    requestFinished()
    const originalRequest = error.config

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        if (keycloak?.authenticated) {
          await keycloak.updateToken(30)
          if (keycloak.token) {
            if (keycloak.refreshToken) {
              saveTokens({
                token: keycloak.token,
                refreshToken: keycloak.refreshToken,
                idToken: keycloak.idToken,
              })
            }
            originalRequest.headers.Authorization = `Bearer ${keycloak.token}`
            return api(originalRequest)
          }
        }
      } catch {
        // caller / onTokenExpired handles re-auth
      }
    }

    return Promise.reject(error)
  }
)

export default api
